import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { get } from 'lodash';
import {
  defaultDisabledFeatureMessage,
  licenseTypes,
  platformFeatures,
} from 'shared/constants';
import {
  getCurrentUserCompany,
  isFeatureAvailable,
  isFeatureEnabled,
} from 'shared/helpers';
import { Selector } from 'shared/components';
import LicenseNotAvailableMessage from './components/LicenseNotAvailableMessage';
import { useTranslation } from 'react-i18next';

const LicenseTypeSelector = ({ handleLicenseChange, selectedLicense }) => {
  const { t } = useTranslation();
  const licenseTypeOptions = [
    {
      label: t(licenseTypes.perpetual),
      value: licenseTypes.perpetual,
      isOptionAvailable: isFeatureAvailable(platformFeatures.model_perpetual),
      isOptionEnabled: isFeatureEnabled(platformFeatures.model_perpetual),
      isDisabled: !(
        isFeatureAvailable(platformFeatures.model_perpetual) &&
        isFeatureEnabled(platformFeatures.model_perpetual)
      ),
      disabledMessage: !isFeatureAvailable(platformFeatures.model_perpetual) ? (
        <LicenseNotAvailableMessage type={platformFeatures.model_perpetual} />
      ) : (
        t(defaultDisabledFeatureMessage)
      ),
    },
    {
      label: t(licenseTypes.time_limited),
      value: licenseTypes.time_limited,
      isOptionAvailable: isFeatureAvailable(
        platformFeatures.model_time_limited,
      ),
      isOptionEnabled: isFeatureEnabled(platformFeatures.model_time_limited),
      isDisabled: !(
        isFeatureAvailable(platformFeatures.model_time_limited) &&
        isFeatureEnabled(platformFeatures.model_time_limited)
      ),
      disabledMessage: !isFeatureAvailable(
        platformFeatures.model_time_limited,
      ) ? (
        <LicenseNotAvailableMessage
          type={platformFeatures.model_time_limited}
        />
      ) : (
        t(defaultDisabledFeatureMessage)
      ),
    },
    {
      label: t(licenseTypes.subscription),
      value: licenseTypes.subscription,
      isOptionAvailable: isFeatureAvailable(
        platformFeatures.model_subscription,
      ),
      isOptionEnabled: isFeatureEnabled(platformFeatures.model_subscription),
      isDisabled: !(
        isFeatureAvailable(platformFeatures.model_subscription) &&
        isFeatureEnabled(platformFeatures.model_subscription)
      ),
      disabledMessage: !isFeatureAvailable(
        platformFeatures.model_subscription,
      ) ? (
        <LicenseNotAvailableMessage
          type={platformFeatures.model_subscription}
        />
      ) : (
        t(defaultDisabledFeatureMessage)
      ),
    },
    {
      label: t(licenseTypes.consumption),
      value: licenseTypes.consumption,
      isOptionAvailable: isFeatureAvailable(platformFeatures.model_consumption),
      isOptionEnabled: isFeatureEnabled(platformFeatures.model_consumption),
      isDisabled: !(
        isFeatureAvailable(platformFeatures.model_consumption) &&
        isFeatureEnabled(platformFeatures.model_consumption)
      ),
      disabledMessage: !isFeatureAvailable(
        platformFeatures.model_consumption,
      ) ? (
        <LicenseNotAvailableMessage type={platformFeatures.model_consumption} />
      ) : (
        t(defaultDisabledFeatureMessage)
      ),
    },
  ];

  return (
    <Selector
      options={licenseTypeOptions}
      value={selectedLicense}
      handleChange={handleLicenseChange}
    />
  );
};

LicenseTypeSelector.propTypes = {
  currentCompany: PropTypes.number,
  handleLicenseChange: PropTypes.func.isRequired,
  selectedLicense: PropTypes.string,
};

LicenseTypeSelector.defaultProps = {
  currentCompany: null,
  selectedLicense: null,
};

const mapStateToProps = (state) => ({
  currentCompany: get(getCurrentUserCompany(state), 'id'),
});

export default connect(mapStateToProps)(LicenseTypeSelector);
